var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxComponent',_vm._b({staticClass:"field-checkbox",model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'CheckboxComponent',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }